var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5607 2.56066C14.1464 1.97487 14.1464 1.02513 13.5607 0.43934C12.9749 -0.146447 12.0251 -0.146447 11.4393 0.43934L0.43934 11.4393C0.295525 11.5832 0.187018 11.7489 0.113818 11.9258C0.0404783 12.1027 0 12.2966 0 12.5C0 12.7034 0.0404783 12.8973 0.113818 13.0742C0.187018 13.2511 0.295525 13.4168 0.43934 13.5607L11.4393 24.5607C12.0251 25.1464 12.9749 25.1464 13.5607 24.5607C14.1464 23.9749 14.1464 23.0251 13.5607 22.4393L5.12132 14H23.5C24.3284 14 25 13.3284 25 12.5C25 11.6716 24.3284 11 23.5 11H5.12132L13.5607 2.56066Z",
    fill: "#8400E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBackButton);
export default __webpack_public_path__ + "static/media/arrow-back-button.62984a08bc26512927ee649446f386e9.svg";
export { ForwardRef as ReactComponent };